import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditLeasingForm } from "web_myplann/Portfolio/Pages/LeasingEdit/EditLeasingForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditLeasingPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.Leasing}
			title={t(Resources.Portfolio.EditPortfolio.title)}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditLeasingForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
